import { Button } from "components/atoms/button/button";
import { rem } from "polished";
import styled from "styled-components";
import { breakpoints } from "styles";

export const RateClassModalHeader = styled.div`
  text-align: center;
`;

export const RateClassModalImgContainer = styled.div<{
  width?: number;
  height?: number;
}>`
  width: ${({ width }) => `${width || 64}px`};
  height: ${({ height }) => `${height || 64}px`};
  position: relative;
  margin: auto;
`;

export const RateClassModalHeading = styled.h2<{
  fontSize?: number;
}>`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme, fontSize }) =>
    fontSize ? `${fontSize}px` : theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.neutral[900]};
  line-height: 36px;
  margin: 16px 0 4px;
`;

export const RateClassModalSubHeading = styled.h4`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  line-height: 28px;
  margin: 0;
  margin-bottom: 10px;
`;

export const RateClassModalContent = styled.div`
  margin: 24px 0;
  text-align: center;
`;

export const RateClassModalFooter = styled.div`
  text-align: center;
`;
export const RateClassModalCTAContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(24)};
  & > * {
    flex: 1;
  }
`;

export const RateClassModalFooterNote = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin-top: 1rem;
  color: #72839e;
`;

export const RateClassModalNote = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: 400;
  line-height: 24px;
  color: #72839e;
`;

export const RateClassChipsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin: 16px 0;
  align-items: center;
  justify-content: center;
`;

export const TextAreaWrapper = styled.div`
  width: 100%;
  margin: auto;
`;

export const RateClassChip = styled.div<{
  selected?: boolean;
}>`
  text-align: center;
  padding: 6px 14px;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  line-height: 24px;
  cursor: pointer;
  font-weight: ${({ selected }) => (selected ? "700" : "400")};
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.brand[50] : theme.colors.white};
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme, selected }) =>
    selected ? theme.colors.brand[500] : theme.colors.periwinkle[400]};
  border-radius: 20px;
  color: ${({ theme, selected }) =>
    selected ? theme.colors.brand[500] : "#72839e"};
  @media ${breakpoints.laptop} {
    white-space: nowrap;
  }
`;

export const StyledSubmitButton = styled(Button)`
  width: 320px;
  margin: 0 auto;
`;
